import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@fortawesome/fontawesome-free/css/all.min.css';

import './Login.scss';
import { useGameReducer } from '../../Store';
import { UserActions } from '../../Store/Actions';

export const LoginWithLink =  () => {

  const { code } = useParams();
  const [error, setError] = useState(false);
  const { t } = useTranslation();

  const gameReducer = useGameReducer();

  useEffect(() => {
    if (gameReducer.token) {
      UserActions.getUserDetails();
    }
  }, [gameReducer.token]);

  const login = () => {
    setError(false);
    if (code) {
      UserActions.loginWithCode(code).catch(() => {
        setError(true);
      });
    } else {
      setError(true);
    }
  };

  return (
    <div className='login_div'>
      { code && (
        <>
          <h1>Welcome!</h1>
          <Button variant='contained' className='header_btn' onClick={login}>
            {t('login.submitButton')}
          </Button>
        </>
      )}
      { !code && (
        <>
          Invalid code!
        </>
      )}
      { error && (
        <div className='error_message'>
          <div className="subject">{t('login.errorOnLink')}</div>
          <div className="message">{t('login.errorOnLink.description')}</div>
        </div>
      )}
    </div>
  );
};
